export const EXCEPT_PATH_LIST = ['/']
export const LAYOUT_SPACING = 1